export default {
  updateFilterColor (state, val) {
    state.filter.color = val;
  },

  deleteFilterColor (state, index) {
    state.filter.color.splice(index, 1);
  },

  updateFilterCategory (state, val) {
    state.filter.category = val;
  },

  deleteFilterCategory (state, index) {
    state.filter.category.splice(index, 1);
  },

  updateFilterOpacity (state, val) {
    state.filter.opacity = val;
  },

  updateSearchValue (state, value = '') {
    state.searchValue = value;
  },

  deleteFilterOpacity (state, index) {
    state.filter.opacity.splice(index, 1);
  },
}
